export const Endpoints = {
  company: {
    base: 'company',
    register: 'register',
    getById: (id: number | string) => `${id}`,
    getAll: '',
    create: '',
    update: '',
    getVoucherFiles: (id: number | string) => `${id}/voucherFiles`,
    getAccountSettings: 'accountSettings', 
    updateAccountSettings: 'accountSettings', 
    getUserProfile: (id: number | string) => `userProfile/${id}`,
    deleteUserProfile: (id: number | string) => `userProfile/${id}`,
    updateUserProfile:  'userProfile',
    createUserProfile:  'userProfile', 
    sendWelcomeEmail: (email: string) => `welcomeEmail?email=${email}`,
    downloadFile: 'downloadFile',
    getW9: (id: number | string) => `${id}/w9`,
    getAllW9: `W9`,
    getAllW9NotApproved: `W9NotApproved`,
    updateW9Status: 'updateW9Status',
    uploadW9: (id: number | string) => `${id}/uploadW9`,
    sendEmailOtp: (email: string) => `sendEmailOtp?email=${email}`,
    verifyEmailOtp:  'verifyEmailOtp',
    secure: 'secure',
    canDeleteAccount: (id: number | string) => `${id}/canDelete`,
    deleteAccount: (id: number | string) => `${id}`,
    getCompanyEIN: (id: number | string) => `${id}/ein`,
    uploadNewW9: (id: number | string, ein: string) =>`${id}/${ein}/UploadNewW9`,
    sendW9VerificationEmails: (id: number | string) => `sendW9VerificationEmails/${id}`,
  },
  vaccine: {
    base: 'vaccine',
    getById: (id: number | string) => `${id}`,
    getAll: '',
    create: '',
    update: (id: number | string) => `${id}`    
  },
  voucherProgram: {
    base: 'voucherProgram',
    getById: (id: number | string) => `${id}`,
    getAll: '',
    create: '',
    update: (id: number | string) => `${id}`,
    delete: (id: number | string) => `${id}`,    
  },
   lookupPrefix: {
    base: 'lookupPrefix',
    byId: (id: number | string) => `${id}`,
    getAll: '',
    create: '',
    update: (id: number | string) => `${id}`    
  },
   lookupSuffix: {
    base: 'lookupSuffix',
    byId: (id: number | string) => `${id}`,
    getAll: '',
    create: '',
    update: (id: number | string) => `${id}`    
  },
   lookupEntityType: {
    base: 'lookupEntityType',
    byId: (id: number | string) => `${id}`,
    getAll: '',
    create: '',
    update: (id: number | string) => `${id}`    
  },
   lookupIndustry: {
    base: 'lookupIndustry',
    byId: (id: number | string) => `${id}`,
    getAll: '',
    create: '',
    update: (id: number | string) => `${id}`    
  },
  lookupState: {
    base: 'lookupState',
    byId: (id: number | string) => `${id}`,
    getAll: '',
    create: '',
    update: (id: number | string) => `${id}`    
  },
  faq: {
    base: 'faq',
    get: ''
  },
};